// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Layout, Menu, Icon,
  Dropdown, Avatar, Spin,
} from 'antd';
import { ContainerQuery } from 'react-container-query';
import classNames from 'classnames';
import { askForPermissioToReceiveNotifications } from '../../push-notification';
import { Main, Login } from '../';
import { Auth, Global } from '../../models';
import { HeaderSearch } from '../../components';
import { s3Host } from '../../utils';
import styles from './style.less';
import person from './person.png';

const {
  Header,
  Sider,
  Content,
  Footer,
} = Layout;

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
  },
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      collapsed: false,
    };
  }

  async componentWillMount() {
    let token = await askForPermissioToReceiveNotifications();
    await this.props.logged(token);

    // await this.props.loadCategoryDistrict();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isLoaded && this.props.auth.isLoading === true && nextProps.auth.isLoading === false) {
      this.setState({ isLoaded: true });
    }

    // if (!this.state.isLoaded && this.props.global.isGlobalLoading === true && nextProps.global.isGlobalLoading === false) {
    //   this.setState({ isLoaded: true });
    // }

    if (this.props.auth && this.props.auth.isLogged === true && nextProps.auth.isLogged === false) {
      this.props.history.push('/login');
    }
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  shopImage = ("https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload/upload/96d87615-80a9-4964-dfbe-9cc64e660a04.png");

  render() {
    const {
      auth: {
        user: currentUser,
      },
    } = this.props;
    const menu = (
      <Menu className={styles.menu} overlay={menu} trigger={['click']}>
        <Menu.Item key="logout"><a onClick={() => this.props.logout()}><Icon type="logout" />Гарах</a></Menu.Item>
      </Menu>
    );
    return this.state.isLoaded && (
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route>
          <ContainerQuery query={query}>
            {params => (
              <div className={classNames(params)}>
                <Layout>
                  <Sider
                    trigger={null}
                    collapsible
                    collapsed={this.state.collapsed}
                    breakpoint="md"
                    onCollapse={(collapsed, type) => { console.log(collapsed, type); }}
                    width={288}
                    className={styles.sider}
                  >
                    <div className={styles.logo}>
                      {currentUser.name ? (
                        <Link to="/">
                          <img src={`${s3Host}${currentUser.store.logo}`} alt={currentUser.name} style={{ width: 48, height: 48 }} />
                          <h1 style={{ color: '#333' }} > { currentUser.name } </h1>
                        </Link>
                      )
                      : null
                      }
                    </div>
                    <Menu
                      theme="light"
                      mode="inline"
                      defaultSelectedKeys={[this.props.location.pathname.split('/')[1]]}
                      inlineCollapsed={this.state.collapsed}
                      style={{ width: '100%', borderRight: 'none' }}
                    >
                      {/* <Menu.Item key="1" className={styles.sidebarProfile}>
                        <div className={styles.sidebarProfile}>
                          {isLogged ? (
                            <Dropdown overlay={menu} trigger={['click']}>
                              <span className={`${styles.action} ${styles.account}`}>
                                {currentUser.avatar ?
                                  <Avatar className={styles.shopImage} src="https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload/upload/01f817b1-0935-4c4f-f0fb-cca1c603ec45.png" />
                                :
                                  <Avatar className={styles.shopImage} src={person} />
                              }
                                <span>{currentUser.name}</span>
                              </span>
                            </Dropdown>
                          ) : <Spin size="small" style={{ marginLeft: 8 }} />
                        }
                        </div>
                      </Menu.Item> */}
                      <Menu.Item key="orders" className={styles.sidebarList}>
                        <NavLink to={`/orders`}>
                          <Icon type="inbox" />
                          <span className={styles.sidebarLinks}>Захиалга</span>
                        </NavLink>
                      </Menu.Item>
                      <Menu.Item key="products" className={styles.sidebarList}>
                        <NavLink to={`/products`}>
                          <Icon type="folder" />
                          <span className={styles.sidebarLinks}>Бараа</span>
                        </NavLink>
                      </Menu.Item>
                      <Menu.Item key="homepage" className={styles.sidebarList}>
                        <NavLink to={`/homepage`}>
                          <Icon type="home" />
                          <span className={styles.sidebarLinks}>Загвар</span>
                        </NavLink>
                      </Menu.Item>
                      <Menu.Item key="categories" className={styles.sidebarList}>
                        <NavLink to={`/categories`}>
                          <Icon type="tags" />
                          <span className={styles.sidebarLinks}>Категори</span>
                        </NavLink>
                      </Menu.Item>
                      <Menu.Item
                        key="log"
                        className={styles.sidebarList}
                      >
                        <NavLink to={`/log`}>
                          <Icon type="save" />
                          <span className={styles.sidebarLinks}>Захиалгын лог</span>
                        </NavLink>
                      </Menu.Item>
                      {
                        this.props.auth && this.props.auth.user && this.props.auth.user.root &&
                        <Menu.Item key="district" className={styles.sidebarList}>
                          <NavLink to={`/district`}>
                            <Icon type="environment-o" />
                            <span className={styles.sidebarLinks}>Хүргэлт хийх дүүрэг, хороо</span>
                          </NavLink>
                        </Menu.Item>
                      }
                      {
                        this.props.auth && this.props.auth.user && this.props.auth.user.root &&
                        <Menu.Item key="users" className={styles.sidebarList}>
                          <NavLink to={`/users`}>
                            <Icon type="user" />
                            <span className={styles.sidebarLinks}>Админ</span>
                          </NavLink>
                        </Menu.Item>
                      }
                    </Menu>
                  </Sider>
                  <Layout>
                    <Header className={styles.header}>
                      <Icon
                        className={styles.trigger}
                        type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                        onClick={this.toggle}
                      />
                      <div className={styles.right}>
                        <HeaderSearch
                          className={`${styles.action} ${styles.search}`}
                          placeholder="Хайх..."
                          onSearch={(value) => {
                            console.log('input', value); // eslint-disable-line
                          }}
                          onPressEnter={(value) => {
                            console.log('enter', value); // eslint-disable-line
                          }}
                        />
                        {currentUser.name ? (
                          <Dropdown overlay={menu} trigger={['click']}>
                            <span className={`${styles.action} ${styles.account}`}>
                              {/*
                              {currentUser.avatar ?
                                <Avatar size="small" className={styles.avatar} src={person} />
                              :
                                <Avatar className={styles.shopImage} src={`${s3Host}${currentUser.store.logo}`} />
                              }
                              */}
                              <Avatar size="small" className={styles.avatar} src={person} />
                              {currentUser.name}
                            </span>
                          </Dropdown>
                      ) : <Spin size="small" style={{ marginLeft: 8 }} />}
                      </div>
                    </Header>
                    <Content style={{ margin: '24px 24px 0', height: '100%' }}>
                      <div style={{ minHeight: 'calc(100vh - 260px)' }}>
                        <Main />
                      </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }} className={styles.FooterWrap}>
                      UBinfo - Shop Vendor ©2018 Slide Ltd
                    </Footer>
                  </Layout>
                </Layout>
              </div>
              )}
          </ContainerQuery>
        </Route>
      </Switch>
    );
  }
}

App.defaultProps = {
};

App.propTypes = {
  auth: PropTypes.object.isRequired,
  // collapsed: PropTypes.bool.isRequired,
  // onCollapse: PropTypes.func.isRequired,
  // loadDistrict: PropTypes.func.isRequired,
  // loadCategory: PropTypes.func.isRequired,
  // loadCategoryDistrict: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  logged: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const { auth, global: { collapsed, fetchingNotices, notices } } = state;
  return {
    auth,
    collapsed,
    fetchingNotices,
    notices,
  };
};

const mapDispatchToProps = {
  logged: Auth.logged,
  logout: Auth.logout,
  loadDistrict: Global.loadDistrict,
  onCollapse: Global.onCollapse,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js